<template>
  <div class="main">
    <div class="main-top">
      <div class="main-top-left">
        <el-image v-if="pageDataList.headImg" style="width: 64px; height: 64px; border-radius: 50%; border: 2px solid rgba(255,255,255,1)" :src="pageDataList.headImg.smallHeadImg" @click="showImg(pageDataList.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        <div style="margin-left: 16px; color: #ffffff; line-height: 1.6; font-size: 13px;">
          <p>
            {{pageDataList.age}}岁 · {{pageDataList.height}}cm · {{pageDataList.city}} · {{pageDataList.salaryMin == -1 ? '不限' : pageDataList.salaryMin}}-{{pageDataList.salaryMax == -1 ? '不限' : pageDataList.salaryMax + 'k'}} · {{pageDataList.education ? educationArray[pageDataList.education - 1] : ''}}</p>
<!--          <p>进入情况：{{pageDataList.enterType == -1?'未进入':pageDataList.enterType == 0?'免费进入':pageDataList.enterType == 1?'邀请码进入':pageDataList.enterType == 2?'认证费用':pageDataList.enterType == 3?'保证金进入+认证费用':pageDataList.enterType == 4?'保证金+邀请码':pageDataList.enterType == 5?'直接进入':pageDataList.enterType == 6?'芝麻认证进入':pageDataList.enterType == 7?'身份证直接进入':pageDataList.enterType == 8?'H5直接进入':pageDataList.enterType == 9?'百度认证直接进入':'&#45;&#45;'}}</p>-->
          <p>进入包名：{{pageDataList.enterPackageName}}</p>
          <p>进入渠道：{{pageDataList.channelShowInfo}}</p>
          <p>跟进人：{{pageDataList.customerWechatId}}</p>
        </div>
      </div>
      <div class="wechat" v-if="pageDataList.wechatImg">
<!--        <span>微信二维码</span>-->
        <GetPlain class="wechat-img" :url="pageDataList.wechatImg" :uid="pageDataList.uid" :type="11" :subType="0"/>
      </div>
    </div>
    <el-descriptions style="margin-top: 24px;" title="用户信息" :column="2" size="small" border>
      <el-descriptions-item label="UID" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.uid}}
      </el-descriptions-item>
      <el-descriptions-item label="身份证实名" label-class-name="my-label" class-name="my-item">
<!--        <p v-if="pageDataList.identityAuth"  class="cursor" @click="showIdentityImg">-->
        <p v-if="pageDataList.identityAuth">
          <span v-if="pageDataList.identityAuth.identityState == 2 || pageDataList.identityAuth.zhimaState == 1 || pageDataList.identityAuth.baiduState == 1">
          {{ pageDataList.identityAuth.identityState == 2?pageDataList.identityAuth.identityName:pageDataList.identityAuth.zhimaState == 1?pageDataList.identityAuth.zhimaCertName + '（芝麻）':pageDataList.identityAuth.baiduState == 1?pageDataList.identityAuth.baiduCertName + '（百度）':'' }}
          </span>
          <span v-else>
            {{ pageDataList.identityAuth.identityName }}
          </span>
          <span class="cursor" @click="showIdentityImg" style="color: #409eff; margin-left: 8px;">查看</span>
        </p>
      </el-descriptions-item>
      <el-descriptions-item label="昵称" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.nickName }}<span style="color: #ff0000; margin-left: 8px;">{{pageDataList.svipState > 0 ? "SVIP" :pageDataList.vipState > 0 ? "VIP" : ""}}</span>
      </el-descriptions-item>

      <el-descriptions-item label="身份证号码" label-class-name="my-label" class-name="my-item">
        <!--        {{ pageDataList.identityAuth?pageDataList.identityAuth.identityCode:''  }}-->
        <div v-if="pageDataList.identityAuth">
          <div v-if="pageDataList.identityAuth.identityState == 2 || pageDataList.identityAuth.zhimaState == 1 || pageDataList.identityAuth.baiduState == 1">
            <p v-if="pageDataList.identityAuth.identityState == 2"><get-plain-dialog title="" :code="pageDataList.identityAuth.identityCode" :uid="pageDataList.uid" :type="10" :subType="1"/></p>
            <p v-else-if="pageDataList.identityAuth.zhimaState == 1"><get-plain-dialog title="" :code="pageDataList.identityAuth.zhimaCertCode" :uid="pageDataList.uid" :type="10" :subType="2"/></p>
            <p v-else-if="pageDataList.identityAuth.baiduState == 1"><get-plain-dialog title="" :code="pageDataList.identityAuth.baiduCertCode" :uid="pageDataList.uid" :type="10" :subType="3"/></p>
          </div>
          <div v-else>
            <get-plain-dialog title="" :code="pageDataList.identityAuth.identityCode" :uid="pageDataList.uid" :type="10" :subType="1"/>
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="性别" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.sex==1?'男':pageDataList.sex==2?'女':''}}
      </el-descriptions-item>
      <el-descriptions-item label="籍贯地址" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.nativePlace }}
      </el-descriptions-item>
      <el-descriptions-item label="年龄" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.age }}岁
      </el-descriptions-item>

      <el-descriptions-item label="手机号码" label-class-name="my-label" class-name="my-item">
        <!--        {{ pageDataList.phone}}-->
        <get-plain-dialog title="" :code="pageDataList.phone" :uid="pageDataList.uid" :type="9" :subType="0"/>
      </el-descriptions-item>
      <el-descriptions-item label="生日" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.sysBirthday }}
      </el-descriptions-item>
      <el-descriptions-item label="期望结婚时间" label-class-name="my-label" class-name="my-item">
        {{pageDataList.marryTime==1 ? "半年内" : pageDataList.marryTime - 1 + "年内"}}
      </el-descriptions-item>
      <el-descriptions-item label="身高" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.height }}cm
      </el-descriptions-item>
      <el-descriptions-item label="婚姻状况" label-class-name="my-label" class-name="my-item">
        {{pageDataList.marryState == 1? '未婚' : pageDataList.marryState == 2? '离异' : pageDataList.marryState == 2? '丧偶' : ''}}
      </el-descriptions-item>
      <el-descriptions-item label="体重" label-class-name="my-label" class-name="my-item">
        {{ pageDataList.weight }}kg
      </el-descriptions-item>
      <el-descriptions-item label="子女情况" label-class-name="my-label" class-name="my-item">
        {{pageDataList.childState == 1 ? '没有' : pageDataList.childState == 2 ? '有.和我住一起' : pageDataList.childState == 3 ? '有.有时和我住一起' : pageDataList.childState == 4 ? '有.不和我住一起' : '--'}}
      </el-descriptions-item>
      <el-descriptions-item label="学历" label-class-name="my-label" class-name="my-item">
        {{pageDataList.education == 1 ? "初中" : pageDataList.education == 2 ? "中专/职高/技校" : pageDataList.education == 3 ? "高中" : pageDataList.education == 4 ? "大专" : pageDataList.education == 5 ? "本科" : pageDataList.education == 6 ? "硕士" : pageDataList.education == 7 ? "博士" : pageDataList.education == 8 ? "博士后" : "--"}}
      </el-descriptions-item>
      <el-descriptions-item label="是否吸烟" label-class-name="my-label" class-name="my-item">
        {{pageDataList.somke == 1 ? '不吸，很反感' : pageDataList.somke == 2 ? '不吸烟，但不反感' : pageDataList.somke == 3 ? '社交时偶尔吸烟' : pageDataList.somke == 4 ? '烟不离手' : '--'}}
      </el-descriptions-item>
      <el-descriptions-item label="职业" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.authJob">{{pageDataList.authJob.profession}} - {{ pageDataList.authJob.position}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="是否喝酒" label-class-name="my-label" class-name="my-item">
        {{pageDataList.drink == 1 ? '不喝酒' : pageDataList.drink == 2 ? '社交需要时喝' : pageDataList.drink == 3 ? '兴致时小酌' : pageDataList.drink == 4 ? '酒不离手' : '--'}}
      </el-descriptions-item>
<!--      <el-descriptions-item label="月收入" label-class-name="my-label" class-name="my-item">-->
<!--        {{pageDataList.salaryMin == -1 ? '不限' : pageDataList.salaryMin}}-{{pageDataList.salaryMax == -1 ? '不限' : pageDataList.salaryMax + 'k'}}-->
<!--      </el-descriptions-item>-->
      <el-descriptions-item label="年收入" label-class-name="my-label" class-name="my-item" v-if="pageDataList.annualSalary > 0">
        {{pageDataList.annualSalaryName}}
      </el-descriptions-item>
      <el-descriptions-item label="月收入" label-class-name="my-label" class-name="my-item">
        {{pageDataList.salaryMin == -1 ? '不限' : pageDataList.salaryMin}}-{{pageDataList.salaryMax == -1 ? '不限' : pageDataList.salaryMax + 'k'}}
      </el-descriptions-item>
      <el-descriptions-item label="家庭排行" label-class-name="my-label" class-name="my-item">
        {{pageDataList.familyOrder == 1 ? '其他' : pageDataList.familyOrder == 2 ? '独生子女' : pageDataList.familyOrder == 3 ? '老大' : pageDataList.familyOrder == 4 ? '老二' : pageDataList.familyOrder == 5 ? '老三' : pageDataList.familyOrder == 6 ? '老四' : pageDataList.familyOrder == 7 ? '老五' : '--'}}
      </el-descriptions-item>
      <el-descriptions-item label="现居城市" label-class-name="my-label" class-name="my-item">{{ pageDataList.province }} - {{ pageDataList.city }}</el-descriptions-item>
      <el-descriptions-item label="父母情况" label-class-name="my-label" class-name="my-item">
        {{pageDataList.parentState == 1 ? '父母健在' : pageDataList.parentState == 2 ? '单亲家庭' : pageDataList.parentState == 3 ? '父亲健在' : pageDataList.parentState == 4 ? '母亲健在' : pageDataList.parentState == 5 ? '父母均离世' : '--'}}
      </el-descriptions-item>
      <el-descriptions-item label="家乡" label-class-name="my-label" class-name="my-item">{{ pageDataList.homeProvince }} - {{ pageDataList.homeCity }}</el-descriptions-item>
      <el-descriptions-item label="偏爱约会方式" label-class-name="my-label" class-name="my-item">
        {{pageDataList.tryst == 1 ? '一起看电影' : pageDataList.tryst == 2 ? '共进晚餐' : pageDataList.tryst == 3 ? '共赴浪漫之旅' : pageDataList.tryst == 4 ? '牵手漫步公园' : pageDataList.tryst == 5 ? '彼此相依相偎' : '--'}}
      </el-descriptions-item>
      <el-descriptions-item label="自我介绍" label-class-name="my-label" class-name="my-item" span="2">
        <p style="line-height: 1.5; margin: 4px 0;">{{ pageDataList.pdesc }}</p>
      </el-descriptions-item>
      <el-descriptions-item label="信息标签" label-class-name="my-label" class-name="my-item" span="2">
        <div v-if="pageDataList.userTagList">
          <div class="tag-list" style="margin-top: 4px;">
            <label class="tag-title">关于我：</label>
            <div style="flex: 1"><el-tag class="tap-item" v-for="(item,index) in pageDataList.userTagListMe" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag></div>
          </div>
          <div class="tag-list">
            <label class="tag-title">理想的Ta：</label>
            <div style="flex: 1"><el-tag class="tap-item" v-for="(item,index) in pageDataList.userTagListTa" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag></div>
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="相册图片" label-class-name="my-label" class-name="my-item" span="2">
        <div style="margin-top: 8px;">
          <el-image
              style="width: 56px; height: 56px; margin: 0 6px 0 0;"
              fit="cover"
              v-for="(item, index) in pageDataList.photoList"
              :key="item.id"
              :src="item.smallImg"
              @click="showPhotoImg(index, pageDataList.photoList)"
              class="cursor">
          <template #error><div class="el-img-error">暂无图片</div></template></el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions style="margin-top: 24px;" title="认证信息" :column="2" size="small" border>
      <el-descriptions-item label="身份认证" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.identityAuth">{{pageDataList.identityAuth.identityState == 0?'未提交':pageDataList.identityAuth.identityState == 1?'待认证':pageDataList.identityAuth.identityState == 2?'已认证':pageDataList.identityAuth.identityState == 3?'认证失败':'--'}}</p>
        <p v-else>未认证</p>
      </el-descriptions-item>
      <el-descriptions-item label="视频认证" label-class-name="my-label" class-name="my-item">
        <div style="display: flex; justify-content: space-between">
          <p v-if="pageDataList.authVideo">{{pageDataList.authVideo.state == 3?'不通过':pageDataList.authVideo.state == 2?'已通过':pageDataList.authVideo.state == 1?'待审核':'--'}}</p>
          <p v-else>未上传</p>
          <el-button v-if="pageDataList.authVideo" type="primary" size="small" @click="onPlay(pageDataList.authVideo.videoId)">播放视频</el-button>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="职业认证" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.authJob">{{pageDataList.authJob.jobState == 3?'认证失败':pageDataList.authJob.jobState == 2?pageDataList.authJob.profession + ' - ' +pageDataList.authJob.position:pageDataList.authJob.jobState == 1?'待认证':'--'}}</p>
        <p v-else>未认证</p>
      </el-descriptions-item>
      <el-descriptions-item label="学历认证" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.authEdu">{{pageDataList.authEdu.eduState == 3?'认证失败':pageDataList.authEdu.eduState == 2?educationArray[pageDataList.education - 1] + ' - ' + pageDataList.authEdu.schoolName:pageDataList.authEdu.eduState == 1?'待认证':'--'}}</p>
        <p v-else>未认证</p>
      </el-descriptions-item>
      <el-descriptions-item label="车辆认证" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.authCar">{{pageDataList.authCar.carState == 3?'认证失败':pageDataList.authCar.carState == 2?pageDataList.authCar.carName:pageDataList.authCar.carState == 1?'待认证':'--'}}</p>
        <p v-else>未认证</p>
      </el-descriptions-item>
      <el-descriptions-item label="房产认证" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.authHouse">{{pageDataList.authHouse.houseState == 3?'认证失败':pageDataList.authHouse.houseState == 2?pageDataList.authHouse.city:pageDataList.authHouse.houseState == 1?'待认证':'--'}}</p>
        <p v-else>未认证</p>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions style="margin-top: 24px;" title="择偶标准" :column="2" size="small" border>
      <el-descriptions-item label="年龄" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.ageMin == -1 ? '不限' : pageDataList.spouse.ageMin + '岁'}}-{{pageDataList.spouse.ageMax == -1 ? '不限' : pageDataList.spouse.ageMax + '岁'}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="现居城市" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.province == -1 ? '不限' : pageDataList.spouse.province}}-{{pageDataList.spouse.city == -1 ? '不限' : pageDataList.spouse.city}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="身高" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.heightMin == -1 ? '不限' : pageDataList.spouse.heightMin + 'cm'}}-{{pageDataList.spouse.heightMax == -1 ? '不限' : pageDataList.spouse.heightMax + 'cm'}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="婚姻状况" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.marryState == -1 ? '不限' : pageDataList.spouse.marryState == 1 ? '未婚' : pageDataList.spouse.marryState == 2 ? '离异' : pageDataList.spouse.marryState == 3 ? '丧偶' : '--'}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="学历" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.educationMin == -1 ? '不限' : educationArray[pageDataList.spouse.educationMin - 1]}}-{{pageDataList.spouse.educationMax == -1 ? '不限' : educationArray[pageDataList.spouse.educationMax - 1]}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="子女情况" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.childState == -1 ? '不限' : pageDataList.spouse.childState == 1 ? '没有' : pageDataList.spouse.childState == 2 ? '有.和我住一起' : pageDataList.spouse.childState == 3 ? '有.有时和我住一起' : pageDataList.spouse.childState == 4 ? '有.不和我住一起' : '--'}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="月收入" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.salaryMin == -1 ? '不限' : pageDataList.spouse.salaryMin + 'k'}}-{{pageDataList.spouse.salaryMax == -1 ? '不限' : pageDataList.spouse.salaryMax + 'k'}}</p>
      </el-descriptions-item>
      <el-descriptions-item label="购车、购房" label-class-name="my-label" class-name="my-item">
        <p v-if="pageDataList.spouse">{{pageDataList.spouse.carState == -1 ? '不限' : pageDataList.spouse.carState == 1 ? '无车' : pageDataList.spouse.carState == 2 ? '有车' : '--'}}、{{pageDataList.spouse.houseState == -1 ? '不限' : pageDataList.spouse.houseState == 1 ? '无房' : pageDataList.spouse.houseState == 2 ? '有房' : '--'}}</p>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { getUserDetailInfo, getSysConfig } from "@/api/url";
import { getFormData } from "@/api/api";
import ImgViewer from "@/assets/js/imageViewer";
import GetPlainDialog from "@/components/resume/GetPlainDialog";
import GetPlain from "@/components/resume/GetPlain";
import Dialog from "@/assets/js/dialog";
import VideoPlay from "@/components/VideoPlay";
import IdentityExamineImg from "@/views/review/components/identity/IdentityExamineImg";
export default {
  name: "userInfoDialog",
  components: { GetPlainDialog, GetPlain },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,
      pageDataList: {},
      smallHeadImg: '',
      annualSalaryList: [],
      // 学历
      educationArray: ['初中', '中专/职高/技校', '高中', '大专', '本科', '硕士', '博士'],
    }
  },
  methods: {
    getUserDetailInfo() {
      let param={}
      param['id'] = this.userId
      getFormData(getUserDetailInfo, param).then((data)=>{
        let { code, msg } = data
        if(code == 200) {
          this.pageDataList = data['data'];
          this.smallHeadImg = data['data'].headImg.smallHeadImg;
          if(this.pageDataList.userTagList) {
            this.pageDataList.userTagListMe = []
            this.pageDataList.userTagListTa = []
            for(let i=0; i<this.pageDataList.userTagList.length; i++) {
              if(this.pageDataList.userTagList[i].type == 1) {
                this.pageDataList.userTagListMe.push(this.pageDataList.userTagList[i])
              }else {
                this.pageDataList.userTagListTa.push(this.pageDataList.userTagList[i])
              }
            }
          }
          this.pageDataList.annualSalaryName = ''
          this.annualSalaryList.map(item => {
            if(item.type == this.pageDataList.annualSalary) {
              this.pageDataList.annualSalaryName = item.name
            }
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    showPhotoImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    //视频
    onPlay(id) {
      Dialog.open({
        title: '视频播放',
        component: VideoPlay,
        data: {
          videoId: id,
        }
      })
    },

    showIdentityImg() {
      if(this.pageDataList.identityAuth.imgZ == '' && this.pageDataList.identityAuth.imgF == ''){
        return;
      }
      Dialog.open({
        title: '身份证图片',
        component: IdentityExamineImg,
        data: {
          identityForm: this.pageDataList.identityAuth,
          uid: this.pageDataList.uid,
          width: '1300px'
        },
        confirm: (result) => {

        }
      })
    },

    getSysConfig() {
      getFormData(getSysConfig).then(data => {
        this.annualSalaryList = data.data.annualSalaryList
        this.getUserDetailInfo();
      })
    }

  },
  mounted() {
    this.getSysConfig();
  }
}
</script>

<style scoped>
.main {
  padding: 0 24px 28px;
}
.main-top {
  display: flex;
  justify-content: space-between;
  background-color: #42b983;
  padding: 24px;
  position: relative;
}
.main-top-left {
  display: flex;
  align-items: center
}
.wechat {
  position: absolute;
  right: 24px;
  bottom: -24px;
  text-align: center;
  color: #ffffff;
  /*background-color: #ffffff;*/
  /*padding: 8px;*/
  border-radius: 4px;
  /*border: 1px solid #ededed;*/
  /*box-shadow:  0 4px 8px 4px rgba(0, 0, 0, 0.03);*/
}
.wechat-img {
  border: 3px solid #ffffff;
  margin-top: 8px;
  background-color: #ffffff;
}
.tag-title {
  font-size: 12px;
  margin-bottom: 4px;
  width: 72px;
}
.tap-item {
  margin: 0 4px 4px 0;
  /*display: inline-block;*/
}
.tag-list {
  display: flex;
}
</style>
